import { connect } from 'react-redux';
import { updateEBookDataRoutine } from "redux-state/ducks/player";
import EBookReader from './ebook-reader.component';

const mapStateToProps = ({ player }) => ({
  queue: player.queue,
  ebookData: player.ebookData,
  activeIndex: player.activeIndex,
  isEbookReaderOpen: player.isEbookReaderOpen,
});

const mapDispatchToProps = {
  updateEBookDataAction: updateEBookDataRoutine.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(EBookReader);
